<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="circle" [ngStyle]="{'background-color': color}" [ngClass]="{'inactive': inactive()}"
     pTooltip="{{this.name}} {{this.companyName ? ' (' + this.companyName + ')' : ''}} {{this.inactive() ? ' (' + (translationSchema['utils']['inactive'] | translate) + ')' : ''}}">
  <p class="circle-inner">{{this.personAcronym}}</p>
</div>


